import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { FileIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/payment-management/affiliate-log')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="paymentManagement.affiliatePaymentLogs.crumb.title" icon={FileIcon} />,
      title: <Translation id="paymentManagement.affiliatePaymentLogs.page.title" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
